import React, { FC } from "react";
import { Card, Col, Row, Tabs } from "antd";
import { } from "antd";
import ComparativePerformance from "./../../../components/CryptoMarkets/ComparativePerformance";
import CryptoCorrelations from "./../../../components/CryptoMarkets/CryptoCorrelations";
import MarketCap from "./../../../components/CryptoMarkets/MarketCap";
import PercentageMarketCap from "./../../../components/CryptoMarkets/PercentageMarketCap";
import TradingVolumes from "./../../../components/CryptoMarkets/TradingVolumes";
import FearAndGreedIndex from "../../../components/CryptoMarkets/FearAndGreedIndex";

const { TabPane } = Tabs;

const CryptoMarkets: FC = () => {
  return (
    <Row justify="center" align="top">
      <Col xs={24} sm={24} md={20}>
        <Card
          className="custom-card-1"
          title={
            <div className="d-flex align-items-center">
              <span className="mr-0_5 fs-36">Crypto Markets</span>
            </div>
          }
        >
          <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
            <Col xs={24} sm={24} md={24}>
              <Tabs defaultActiveKey="1">
                <TabPane tab="Market Cap." key="1">
                  <MarketCap />
                </TabPane>
                <TabPane tab="% of Market Cap." key="2">
                  <PercentageMarketCap />
                </TabPane>
                <TabPane tab="Tradings Volumes" key="3">
                  <TradingVolumes />
                </TabPane>
                <TabPane tab="Crypto Correlations" key="4">
                  <CryptoCorrelations />
                </TabPane>
                <TabPane tab="Comparative Performance" key="5">
                  <ComparativePerformance />
                </TabPane>
                <TabPane tab="Fear & Greed Index" key="6">
                  <FearAndGreedIndex />
                </TabPane>
              </Tabs>
            </Col>
          </Row>
        </Card>
      </Col>
    </Row>
  );
};

export default CryptoMarkets;
